import React, { useState, useEffect } from 'react';
import Modal from '../../../../../components/common/Modal';

const EditExamModal = ({ isOpen, onClose, onEdit, exam }) => {
  const [formData, setFormData] = useState({
    id: null,
    title: '',
    course: '',
    duration: '',
    total_score: '',
    retry_limit: false,
    skippable: false,
    is_free: false,
    status: 'draft',
    instructions: '',
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (exam) {
      setFormData({
        id: exam.id,
        title: exam.title || '',
        course: exam.course || '',
        duration: exam.duration || '',
        total_score: exam.total_score || '',
        retry_limit: exam.retry_limit || false,
        skippable: exam.skippable || false,
        is_free: exam.is_free || false,
        status: exam.status || 'draft',
        instructions: exam.instructions || '',
      });
    }
  }, [exam]);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.title.trim()) newErrors.title = 'عنوان الاختبار مطلوب';
    if (!formData.course.trim()) newErrors.course = 'اختيار الدورة مطلوب';
    if (!formData.duration || formData.duration <= 0) newErrors.duration = 'مدة الاختبار يجب أن تكون أكبر من 0';
    if (!formData.total_score || formData.total_score <= 0) newErrors.total_score = 'الدرجة الكاملة يجب أن تكون أكبر من 0';
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    try {
      await onEdit(formData);
      onClose();
    } catch (error) {
      // Handle error
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSkippableChange = () => {
    setFormData(prev => ({
      ...prev,
      skippable: !prev.skippable
    }));
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="تعديل الاختبار"
      size="2xl"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* عنوان الاختبار */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            عنوان الاختبار
          </label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className={`w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 
              dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
              errors.title ? 'border-red-500' : 'border-gray-300'
            }`}
          />
          {errors.title && (
            <p className="mt-1 text-sm text-red-500">{errors.title}</p>
          )}
        </div>

        {/* اختيار الدورة */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            الدورة
          </label>
          <input
            type="text"
            name="course"
            value={formData.course}
            onChange={handleChange}
            className={`w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 
              dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
              errors.course ? 'border-red-500' : 'border-gray-300'
            }`}
            disabled
          />
        </div>

        {/* مدة الاختبار والدرجة الكاملة */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              مدة الاختبار (بالدقائق)
            </label>
            <input
              type="number"
              name="duration"
              value={formData.duration}
              onChange={handleChange}
              className={`w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 
                dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
                errors.duration ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.duration && (
              <p className="mt-1 text-sm text-red-500">{errors.duration}</p>
            )}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              الدرجة الكاملة
            </label>
            <input
              type="number"
              name="total_score"
              value={formData.total_score}
              onChange={handleChange}
              className={`w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 
                dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
                errors.totalScore ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.totalScore && (
              <p className="mt-1 text-sm text-red-500">{errors.totalScore}</p>
            )}
          </div>
        </div>

        {/* وصف الاختبار */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            وصف الاختبار
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            rows={3}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 
              dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          />
        </div>

        {/* تعليمات الاختبار */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            تعليمات الاختبار
          </label>
          <textarea
            name="instructions"
            value={formData.instructions}
            onChange={handleChange}
            rows={3}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 
              dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          />
        </div>

        {/* خيارات إضافية */}
        <div className="space-y-2">
          <div className="flex items-center">
            <input
              type="checkbox"
              id="skippable"
              name="skippable"
              checked={formData.skippable}
              onChange={handleSkippableChange}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <label htmlFor="skippable" className="mr-2 block text-sm text-gray-700 dark:text-gray-300">
              السماح بتخطي الأسئلة
            </label>
          </div>
          
          <div className="flex items-center">
            <input
              type="checkbox"
              id="is_free"
              name="is_free"
              checked={formData.is_free}
              onChange={(e) => setFormData({...formData, is_free: e.target.checked})}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <label htmlFor="is_free" className="mr-2 block text-sm text-gray-700 dark:text-gray-300">
              الاختبار مجاني
            </label>
          </div>
        </div>

        {/* أزرار التحكم */}
        <div className="flex justify-end space-x-2 rtl:space-x-reverse">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg 
              hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
              dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600"
          >
            إلغاء
          </button>
          <button
            type="submit"
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg 
              hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
              dark:bg-blue-500 dark:hover:bg-blue-600"
          >
            حفظ التغييرات
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default EditExamModal;
